import { gql } from '@/__generated__';

const GET_ACCESS_EVENTS = gql(`#graphql
  query GetAccessEvents {
    authorization {
      authorizationGeneral {
        viewEvents
      }
    }
  }
`);

export default GET_ACCESS_EVENTS;
